import { FormDataType } from "DataTypes/Form";

export const AddNewCaseForm: FormDataType[] = [
  {
    id: "title",
    label: "Title",
    placeholder: "Enter Title",
    boxType: "input-box",
    type: "text",
    boxSize: 12,
    validatetype: "acceptAll",
    required: true,
    multiline: true,
    multilineRows: 4,
  },
];
